import styled from 'styled-components/macro'

export const CustomFieldWrapper = styled.div`
`

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.6rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
`

export const InputText = styled.input`
  display: block;
  width: 100%;
  padding: 1.1rem 1.5rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
  background: #FFFFFF;
  /* Mono/Grey */
  border: 2px solid #E3E6E8;
  border-radius: .6rem;
  transition: border-color .3s;
  margin-bottom: 1rem;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary.default};
    outline: 0;
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.mono.greyLight};
    border-color: ${({ theme }) => theme.colors.mono.grey};
    color: ${({ theme }) => theme.colors.mono.greyDark};
  }
`


export const InputTextArea = styled.textarea`
  width: 100%;
  height: 12rem;
  border: 0.2rem solid ${({ theme }) => theme.colors.mono.greyDark};
  border-radius: 0.6rem;
  resize: none;
  padding: 4px;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary.default};
    outline: 0;
  }
`

export const RequiredBadge = styled.span`
  color: red;
`